<template>
  <div>
    <v-layout column align-center>
      <h1>
        Sorry<v-icon class="pl-3" color="white" size="xx-large">
          mdi-emoticon-sad-outline
        </v-icon>
      </h1>
      <h2>We couldn't find that page.</h2>
      <br />
      <h4>
        Please check the address that brought you here or use the buttons above
        to navigate.
      </h4>
      <h4>Please report any problems to ard-support@maxar.com.</h4>
    </v-layout>
  </div>
</template>

<script>
export default {};
</script>
